const ja = {
    messages: {
        pricing: '料金',
        blog: 'ブログ',
        blogdescription: 'RPA CLOUD に関する最新情報',
        profile: 'プロフィール',
        signout: 'サインアウト',
        signin: 'サインイン',
        tryforfree: '無料で試してみましょう',
        privacypolicy: 'プライバシーポリシー',
        contact: 'お問い合わせ',
        opensettings: '設定を開く',
        signintoocto: '{name} にサインイン',
        welcomeback: 'お帰りなさい！',
        pleasesignin: 'サインインしましょう。',
        email: 'メール',
        password: 'パスワード',
        forgotyourpassword: 'パスワードをお忘れですか？',
        forgotyourpassworddescription: '普段サインインに使用しているメール アドレスを入力します。 アカウントが存在する場合は、パスワードをリセットするために使用できるリセット リンクを電子メールで送信します。',
        emailaddress: 'メールアドレス',
        sendpasswordreset: 'パスワードリセットを送信',
        sendpasswordresetmsg: 'パスワードをリセットするためのリンクを記載したメールを {email} に送信しました。 リンクの有効期限は 10 分間です。',
        resetyourpassword: 'あなたのパスワードをリセット',
        resetyourpassworddescription: '新しいパスワードを入力してください。',
        resetpassword: 'パスワードのリセット',
        newpassword: '新しいパスワード',
        confirmpassword: 'パスワードの確認',
        firstname: '名前',
        lastname: '苗字',
        agreetryforfree: '同意、無料で試します。',
        free: '無料',
        standard: 'Standard',
        premium: 'Premium',
        enterprise: 'Enterprise',
        cooperation: 'Cooperation',
        agreeconfirm: '以下をクリックすると、プライバシーポリシーの条件に同意したことになります。',
        tel: 'Tel',
        useastrongpassword: '強力なパスワードを使用してください',
        whichplanwouldyouliketouse: 'どのパッケージを使用しますか?',
        weak: '弱い',
        okay: '普通',
        good: '良い',
        strong: '強い',
        stronger: 'より強く',
        tooshort: '短すぎ',
        talktous: 'ご相談ください',
        talktousdescription: '以下のフォームにご記入ください。すぐにご連絡させていただきます。',
        talktousdescription2: '直接連絡したほうがよろしいでしょうか?',
        orphone: 'または電話',
        whatcanwehelpwith: '何がお手伝いできるでしょうか?',
        send: '送信',
        phonenumber: '電話番号',
        rpacloudslogan: 'RPA CLOUD - 理想的なアシスタントプロバイダー',
        rpaclouddescription: 'RPA CLOUD は、ユーザーが手頃な価格で繰り返し行うタスクを自動化できる、使いやすいクラウドベースのソフトウェア ロボットです。 年中無休で動作するため、開発者でなくても使用できます。',
        contactsales: '営業者にお問い合わせください',
        feature: '特徴',
        featuredescription: 'RPA CLOUD がもたらすユニークな機能を体験してみましょう。',
        bynow: '今すぐ購入',
        months: '月額',
        standardprice: '¥1,500',
        standarddescription: [
            '1 アカウントが付属',
            '5 体のロボットが付属',
            '5 つのタスクスケジュールが付属',
            '1 GB のストレージ',
            '電子メールサポート',
        ],
        premiumprice: '¥3,500',
        premiumdescription: [
            '1 アカウントが付属',
            '10 体のロボットが付属',
            '10 つのタスクスケジュールが付属',
            '10 個のコネクションが付属',
            '2 GB のストレージ',
            '優先的な電子メールサポート',
        ],
        enterpriseprice: '¥5,000',
        enterprisedescription: [
            '5 アカウントが付属',
            '30 体のロボットが付属',
            '30 つのタスクスケジュールが付属',
            '30 個のコネクションが付属',
            '10 GB のストレージ',
            '電話と電子メールのサポート',
        ],
        cooperationprice: '',
        cooperationdescription: [
            '無制限のアカウントが付属',
            '無制限のロボットが付属',
            '無制限のタスクスケジュールが付属',
            '無制限のコネクションが付属',
            'プライベートストレージ',
            'プライベートサーバー',
            '優先的な支援',
        ],
        tryforstandard: 'Standard を試してみる',
        tryforstandarddescription: 'Standard パッケージを選択しました。',
        agreetryforstandard: '同意、 Standard を試してみる',
        tryforpremium: 'Premium を試してみる',
        tryforpremiumdescription: '料金がかかる Premium パッケージを選択しました。',
        agreetryforpremium: '同意、Premium を試してみる',
        tryforenterprise: 'Enterprise を試してみる',
        tryforenterprisedescription: '料金がかかる Enterprise パッケージを選択しました。',
        agreetryforenterprise: '同意、Enterprise を試してみる',
        searchblog: 'ブログを検索',
        pricingdescription: '当社のパッケージには、Standard、Premium、Enterprise、および Cooperation が含まれています。 あなたのニーズに合ったパッケージをお選びください。',
        close: '閉じる',
        almostdone: 'もうすぐ完成です！',
        pleaseverifyyouremailaddress: 'あなたのメールアドレスを確認してください。',
        wehavesentanemailto: 'メールを次の宛先に送信しました。',
        pleasecheckittoverifyyouremail: 'メールを確認するにはチェックを入れてください。',
        needhelp: 'サポートが必要ですか?',
        contactusat: '次の電話番号までお問い合わせください。',
        resendverificationemail: '確認メールを再送',
        msg_resendverificationemailalert: '{email} にメールを送信しました。 メール内のリンクをクリックしてメールを確認する必要があります。 このリンクは 1 時間有効です。',
        pleaseenteravalidemailaddress: '有効なメールアドレスを入力してください。',
        pleaseenteravalidfirstname: '名前には、文字、スペース、\'-\'、\'.\'、またはアポストロフィのみを含めることができます。',
        pleaseenteravalidlastname: '名字には、文字、スペース、\'-\'、\'.\'、またはアポストロフィのみを含めることができます。',
        pleaseenteravalidpassword: 'パスワードは 8 文字以上、大文字と数字を少なくとも 1 つずつ使用する必要があります。',
        pleaseenteravalidcompanyname: '有効な会社名を入力してください。',
        pleaseenteravalidtelnumber: '有効な電話番号を入力してください。',
        msg_error: 'システムエラーが発生しました。',
        msg_invalidinformation: '無効なメールアドレスまたはパスワード。 もう一度お試しいただくか、お問い合わせください。',
        msg_emailisalreadyexists: 'ご提供いただいたメールアドレスはすでに使用されています。 RPA CLOUD アカウントにサインインしてください。',
        msg_invalidverifyemailtoken: '残念ながら、この確認リンクは有効期限が切れています。 RPA CLOUD にサインインし、[確認メールを再送信] ボタンをクリックして新しいリンクを生成してください。',
        dashboard: 'ダッシュボード',
        dashboarddescription: 'こんにちは、RPA CLOUD へようこそ。',
        cancel: 'キャンセル',
        ok: 'OK',
        signoutconfirm: 'RPA CLOUD アカウントからサインアウトしてもよろしいですか?',
        msg_resetpasswordsuccess: 'パスワードのリセットが成功しました。',
        msg_invalidemail: 'このメール アドレスを持つユーザーは存在しません。',
        passwordisnotmatch: '新しいパスワードと確認用のパスワードが一致しません。',
        msg_thenewpasswordisthesameasthelastpassword: '新しいパスワードは前回のパスワードと同じです。',
        changelanguage: '言語の変更',
        pleaseenteravalidphonenumber: '有効な電話番号を入力して下さい。',
        pleasefilloutthisfield: 'この欄にご記入ください。',
        msg_thanksforcontactingus: 'お問い合わせいただきありがとうございます。 できるだけ早くご連絡させていただきます。',
        registernow: 'アカウントをお持ちでない場合は、 今すぐ登録しましょう。',
        documentation: 'ドキュメント',
        workspace: 'ロボット',
        connection: 'コネクション',
        storage: 'ストレージ',
        storages: 'ストレージ',
        userprofile: 'ユーザープロフィール',
        userinfor: 'ユーザー情報',
        edityouraccountinformation: 'アカウント情報を編集:',
        save: '保存',
        changeyourpassword: 'パスワードを変更する',
        currentpassword: '現在のパスワード',
        dashboarddescription_2: 'ロボットに作業を記憶させることで、定型的な作業を自動で繰り返し実行することができます。',
        dashboarddescription_3: '初心者でも簡単にRPAを実現。',
        dashboarddescription_4: 'ユーザーが画面上で行った操作を視覚的に捉え、ロボットにコマンドを要求することができます。 人間が一つ一つ繰り返していた作業を簡単に行うことができるので、作業負担を軽減できます。',
        upgrade: 'アップグレード',
        currentplan: '現在のパッケージ',
        schedule: 'スケジュール',
        tasksdonetoday: '今日行われたタスク',
        name: '名',
        timezone: 'タイムゾーン',
        description: '説明',
        result: '結果',
        triggers: 'トリガー',
        role: '役割',
        package: 'パッケージ',
        verified: '確認済み',
        yes: 'はい',
        no: 'いいえ',
        success: '成功',
        error: 'エラー',
        administrator: '管理者',
        user: 'ユーザー',
        expiration: '有効期限',
        action: 'アクション',
        upload: 'アップロード',
        active: '有効',
        inactive: '無効',
        status: 'ステータス',
        providerid: 'プロバイダーID',
        size: 'サイズ',
        robotunit: 'ロボット',
        connectunit: 'コネクト',
        gbunit: 'GB',
        taskunit: 'タスク',
        delete: '削除',
        deleted: '削除済み',
        thekeynameisalreadyinuse: 'キー名はすでに使用されています。 一意のキー名を指定してください。',
        createddt: '作成日',
        kind: '種類',
        addnew: '新規追加',
        search: '検索',
        download: 'ダウンロード',
        id: 'ID',
        details: '詳細',
        startdatetime: '開始日時',
        enddatetime: '終了日時',
        histories: '履歴',
        gmail: 'Google メール',
        clicktocopy: 'クリックしてコピー',
        duplicate: '複製',
        build: '構築',
        run: '実行',
        back: '戻る',
        options: 'オプション',
        thisfieldisrequired: 'この項目は必須です。',
        url: 'Url',
        selector: 'セレクタ',
        text: 'テキスト',
        browser: 'ブラウザ',
        outputkey: '出力キー',
        condition: '条件',
        undo: '元に戻す',
        redo: 'やり直し',
        specifycalculation: '計算指定',
        openbrowser: 'ブラウザを開く',
        click: 'クリック',
        if: '条件分岐',
        endif: '条件分岐 < 終了',
        comment: 'コメント',
        miscellaneous: 'その他',
        control: 'コントロール',
        update: 'アップデート',
        rowsperpage: '1ページあたりの行数',
        msg_youraccounthasbeenupdated: 'アカウントが更新されました。',
        msg_fileextensionsarenotallowed: 'ファイルの拡張子は許可されていません。',
        msg_pleaseuploadthefile: 'ファイルをアップロードしてください。',
        msg_fileistoobig: '添付ファイルのサイズが10 MBを超えている。',
        msg_youravatarhasbeenupdated: 'アバターが更新されました。',
        msg_currentpasswordisinvalid: '現在のパスワードは無効です。',
        msg_newpasswordandconfirmpassworddoesnotmatch: '新しいパスワードと確認用のパスワードが一致しません。',
        msg_changepasswordsuccess: 'パスワードが正常に変更されました。',
        addnewuser: '新規ユーザー追加',
        edituser: 'ユーザー更新',
        language: '言語',
        english: 'English',
        vietnamese: 'Tiếng Việt',
        japanese: '日本語',
        languageofverifyemail: '確認メールの言語',
        msg_addnewusersuccess: '新規ユーザーが追加されました。',
        msg_editusersuccess: 'ユーザーが更新されました。',
        msg_inactiveuserwassuccess: 'ユーザーが無効されました。',
        msg_activeuserwassuccess: 'ユーザーが有効されました。',
        msg_deleteuserwassuccess: 'ユーザーが削除されました。',
        confirmactionuser: '選択されたユーザーを {action}したいですか?',
        uploadfile: 'ファイルアップロード',
        filepath: 'ファイルパス',
        projects: 'プロジェクト',
        projectname: 'プロジェクト名',
        members: 'メンバー',
        robots: 'ロボット',
        createddate: '作成日',
        createduser: '作成者',
        projectnameexample: 'デモ用プロジェクト',
        descriptionexample: 'これはデモ用プロジェクトです。',
        deleteprojectconfirm: '本当に削除しますか "{projectName}"?',
        deleteprojectsubtitle: '確認するには[delete]と入力してください。',
        msg_addnewprojectsuccess: '新規プロジェクトを作成しました。',
        msg_editprojectsuccess: 'プロジェクトが更新されました。',
        msg_deleteprojectwassuccess: 'プロジェクトが削除されました。',
        msg_deleteprojecterror: 'このプロジェクトはロボットが含まれているため、削除できません。',
        updaterobot: 'ロボットを更新',
        addnewrobot: 'ロボットを追加',
        robotname: 'ロボット名',
        icon: 'アイコン',
        backgroundcolor: '背景色',
        color: '色',
        sendinganemailwhenanerroroccurs: 'エラー発生時のメール送信',
        msg_addnewscriptsuccess: '新規ロボットが作成されました。',
        msg_editscriptsuccess: 'ロボットが更新されました。',
        msg_deletescriptwassuccess: 'ロボットが削除されました。',
        deletescriptconfirm: '本当に "{scriptName}"を削除したいですか?',
        duplicaterobot: 'ロボットを複製',
        msg_duplicatescriptsuccess: 'ロボットを複製しました。',
        msg_savescriptwassuccess: '保存できました。',
        gmailconnectiondescription: 'ユーザー本人に代わってメール表示と送信',
        googlespreadsheetsconnectiondescription: 'Google スプレッドシートの管理と更新',
        googledriveconnectiondescription: 'Google ドライブファイルの表示と管理',
        googlecalendarconnectiondescription: 'Google カレンダーの管理と更新',
        awss3connectiondescription: 'AWS S3にファイルをアップロッドとダウンロー',
        filemakerconnectiondescription: 'レコードの取込、スクリプトの実行',
        googledocsconnectiondescription: 'Google ドキュメントの管理と更新',
        ftpconnectiondescription: 'FTP にファイルをアップロッドとダウンロー.',
        bucketname: 'バケット名',
        accesskeyid: 'アクセスキーID',
        secretaccesskey: 'シークレットアクセスキー',
        host: 'ホスト',
        version: 'バージョン',
        username: 'ユーザー名',
        database: 'データベース',
        msg_updateconnectionsuccess: 'コネクションが更新されました。',
        msg_createconnectionsuccess: 'コネクションが追加されました。',
        msg_cannotupdateconnection: 'コネクションが更新できません。',
        msg_cannotcreateconnection: 'コネクションが追加できません。',
        connectionlist: 'コネクション一覧',
        msg_pleaseenterthedataintherequiredfield: '必須項目にデータを入力してください。',
        deleteconnectionconfirm: '"{name}"を本当に削除したいですか?',
        msg_deleteconnectionwassuccess: 'コネクションが削除されました。',
        copiedtoclipboard: 'クリップボードにコピーしました。',
        copypath: 'パスをコピー',
        path: 'パス',
        totalsize: 'サイズ合計',
        msg_deletestoragesuccess: 'ファイル/ディレクトリが削除されました。',
        deletedirectoryconfirm: 'ファイル/ディレクトリを本当に削除したいですか?',
        addnewsubdirectory: '新規サブディレクトリを追加',
        uploadfilestodirectory: 'ディレクトリにファイルアップロード',
        directory: 'ディレクトリ',
        directories: 'ディレクトリ',
        actions: 'アクション',
        type: 'タイプ',
        directoryname: 'ディレクトリ名',
        msg_directoryalreadyexists: 'ディレクトリはすでに存在します。',
        msg_addnewsubdirectorysuccess: 'サブディレクトリが追加されました。',
        uploadfilestodirectoryconfirm: ' "{name}" ディレクトリにファイルをアップロードしたいですか?',
        msg_uploadfilessuccess: 'ファイルがアップロードされました。',
        editdirectoryname: 'ディレクトリ名変更',
        msg_updatedirectorysuccess: 'ディレクトリが更新されました。',
        disabled: '無効',
        ready: '完了',
        disable: '無効',
        enable: '有効',
        running: '実行',
        selectrobot: 'ロボット選択',
        edittrigger: 'トリガ修正',
        confirmschedule: 'スケジュール確認',
        next: '次へ',
        msg_addnewschedulesuccess: '新規スケジュールが作成されました。',
        msg_updateschedulesuccess: 'スケジュールが更新されました。',
        msg_deleteschedulewassuccess: 'スケジュールが削除されました。',
        confirmactionschedule: '選択されたスケジュールを {action}したいですか？',
        msg_enableschedulrwassuccess: 'スケジュールが有効されました。',
        msg_disableschedulrwassuccess: 'スケジュールが無効されました',
        msg_expireduser: 'アカウントの有効期限が切れています。',
        expirationnotice: 'RPA CLOUD を使用できる期間は残り {numberOfValidDays} 日です。',
        expirationnotice_2: '利用中止を避けるため、管理者にご連絡ください。',
        runscriptconfirm: '"{scriptName}"を実行したいですか?',
        selectyourprojectname: 'プロジェクト名を選択してください。',
        enteryourrobotname: 'ロボット名を入力してください。',
        screenshot: 'スクリーンショット',
        basicauthusername: 'ユーザー (Basic Auth)',
        basicauthpassword: 'パスワード (Basic Auth)',
        clearvalue: '値を削除',
        keyboards: 'キーボード',
        downloadfile: 'ファイルダウンロード',
        stop: '停止',
        steps: 'ステップ',
        step: 'ステップ',
        acceptdialog: 'ダイアログの承諾',
        paste: 'ペースト',
        copy: 'コピー',
        msg_missingifstep: '"If"ステップが欠落している',
        msg_missingendifstep: ' "End If" ステップが欠落している',
        msg_missingendloopstep: '"End Loop" ステップが欠落している',
        msg_missingloopstep: '"Loop" ステップが欠落している',
        msg_missingendforeachstep: '"End For-each" ステップが欠落している',
        msg_missingforeachstep: '"For-each" ステップが欠落している',
        msg_invalidscriptstep: '無効なスクリプトステップ',
        concatenate: '文字列定数',
        parentheses: '優先順位',
        equalto: '等しい',
        notequalto: '等しくない',
        greaterthan: 'より大きい',
        lessthan: 'より小さい',
        greaterthanorequalto: '大きいか等しい',
        lessthanorequalto: '小さいか等しい',
        carriagereturn: '改行マーク',
        plus: '加算、テキストの結合',
        minus: '減算',
        multiply: '乗算',
        divide: '除算',
        and: 'と',
        or: '又は',
        not: 'ノット',
        get: 'ゲット',
        msg_thespecifiedfieldcannotbefound: ' {caculation}:見つからない',
        msg_missing: '{name}が欠落している',
        textismustbeinbetweendoublequotation: '文字は必ず二重引用符で囲んでください ！(例: "abc")',
        ignoreerror: 'エラー無視',
        actionsfordownload: 'ダウンロードのアクション',
        selectoption: 'ブルダウンリスト選択',
        coordinatex: '座標X',
        coordinatey: '座標Y',
        windowsize: 'ウィンドウサイズ',
        format: 'フォーマット',
        scale: 'スケール',
        pageranges: 'ページ範囲',
        timeout: '(millisecond)タイムアウト',
        findelementby: '要素検索',
        attribute: '属性取得',
        tab: 'タブ切替',
        waitfornavigation: 'セレクターを待つ',
        fullpage: '全ページ',
        targetselector: '対象セレクター',
        destinationselector: '宛先セレクター',
        kill: '停止',
        msg_killschedulewassuccess: 'スケジュールが停止されました。',
        createddatetime: '作成日時',
        view: '確認',
        executor: '実行',
        msg_pleaseupgradeyourplantocreateanewrobot: '新規ロボットを作成するようにパッケージをアップグレードしてください。',
        msg_pleaseupgradeyourplantocreateanewconnection: '新規コネクションを作成するようにパッケージをアップグレードしてください。',
        msg_pleaseupgradeyourplantouploadfile: 'ストレージ容量がいっぱいになっています。不要なファイル/フォルダーの削除、又はパッケージをアップグレードしてください。',
        msg_pleaseupgradeyourplantocreateanewschedule: '新規スケジュールを作成するようにパッケージをアップグレードしてください。',
        termsofuse: '利用規約',
        date: '日にち',
        number: '番号',
        logical: 'ロジカル',
        value: '値',
        gettingstarted: 'はじめよう',
        usage: '利用方法',
        connections: 'コネクション',
        iwouldliketoupgradepackage: 'RPA CLOUDのパッケージをアップグレードしたいのです。',
        message: 'メッセージ',
        pleaseenteravalidphonemessage: '有効な電話番号を入力してください。',
        msg_toomanyrequestsfromthisip: 'この IP からのリクエストが多すぎます。1 時間後にもう一度試してください。',
        benefitsofusingrpacloud: 'RPA CLOUDを利用するメリット',
        benefitsofusingrpaclouddescription: 'RPA CLOUD は反復的なタスクを自動化し、正確な実行を確保しながら時間とコストを節約します。',
        savetime: '時間節約',
        costefficiency: 'コスト効率',
        accuratetask: '正確なタスク',
        howtouserpacloud: 'RPA CLOUD使い方は?',
        howtouserpaclouddescription: 'インターネットに接続された PC があれば、そのシンプルさをお楽しみいただけます。',
        createyourrobot: 'ロボットを作成する',
        createyourrobotdescription: 'これを、コンピューター上のユーザーのアクションを観察して再現できるデジタル アシスタントとして想像してください。自分でタスクを実行するときと同じように、各ステップでロボットをガイドするだけです。',
        testtherobot: 'ロボットをテストする',
        testtherobotdescription: '「実行」機能を利用すると、ロボットが正しくプログラムされており、スムーズかつ効率的な方法で目的のアクションを実行することを確認できます。 ',
        settheschedule: 'スケジュールを設定する',
        setthescheduledescription: 'あなたに代わってロボットに指定されたタスクを実行してもらいたい時間枠を指定します。座ってリラックスして、ロボットに仕事を任せるだけで済みます。',
        uniquefeature: 'RPA CLOUD のユニークな機能を探索する',
        uniquefeaturedescription: 'RPA CLOUD は、Google Chrome、Excel、Gmail、Google Spreadsheet、Google Drive、Google Calendar、Google Docs、AWS S3、FileMaker などの複数のプラットフォームで実行できる多様な機能を提供します。 ',
        code: 'コード',
        incrediblyeasytogetgoing: '信じられないほど簡単に始められます',
        times: '回',
        iterable: '反復可能',
        scheduled: '予定されている',
        msg_cannotdeletescriptbecause: 'ロボットはスケジュールされているため削除できません。',
        freeupto30daysnocreditcardrequired: '30日間までは無料で、クレジットカードは必要ありません。',
        filename: 'ファイル名',
        fullpath: 'フルパス',
        encoding: 'エンコーディング',
        array: '配列',
        object: 'オブジェクト',
        arraydata: '配列データ',
        arrayindex: '配列のインデックス',
        objectdata: 'オブジェクトデータ',
        objectkey: 'オブジェクトのキー',
        createarray: '配列作成',
        element: '要素',
        deleteelement: '要素削除',
        addnewelement: '要素追加',
        key: 'キー',
        deleteobject: 'オブジェクト削除',
        addnewobject: 'オブジェクト追加',
        createobject: 'オブジェクト作成',
        splitwith: 'と分割',
        find: '検索',
        replacewith: 'と置換する',
        regexp: '正規表現',
        sheetname: 'シート名',
        newsheetname: '新シート名',
        worksheet: 'ワークシート',
        celllabel: 'セルラベル',
        range: '範囲',
        headers: 'ヘッダー',
        contents: 'コンテンツ',
        json: 'JSON',
        excel: 'エクセル',
        drive: 'Google ドライブ',
        calendar: 'Google カレンダー',
        installation: 'インストール',
        usageperiod: '利用期間',
        copylink: 'リンクのコピー',
        chromeextension: 'Chrome 拡張機能',
        setvariable: '変数設定',
        runjavascript: 'JavaScript実行',
        subtitle__gettingstarted_installation: 'RPA CLOUDのWebブラウザ機能を利用してWebサイト上の作業を自動化するため、CSS セレクターのコピー用「RPA CLOUD」というChrome 拡張機能をインストール必要です。CSS セレクターは、パーティーに参加する人々の名札のようなもので、名札が人でいっぱいの部屋の中で特定の人を識別するのと同じように、CSS セレクターは Web サイト上の特定の要素を識別します。',
        getcssselector: 'CSSセレクターの取得',
        subtitle__gettingstarted_usage: 'RPA CLOUD の基本的な使い方を学びます。',
        actiontask: 'アクションタスク',
        makeyourfirstrobot: '最初のロボットを作成します。',
        runyourrobot: 'ロボットを実行',
        schedulerobotrun: 'ロボット実行スケジュール設定します。',
        msg_companyName_invalid: '会社名が無効です。',
        msg_telNumber_invalid: '電話番号が無効です。',
        msg_firstName_invalid: '名前が無効です',
        msg_lastName_invalid: '苗字が無効です',
        msg_password_invalid: 'パスワードが無効です。',
        msg_plan_invalid: 'パッケージが無効です。',
        msg_locale_invalid: 'ロケールが無効です。',
        msg_paymentfailed: '支払いに失敗しました。もう一度試してください。',
        msg_paymentsuccess: '支払成功',
        chromiumtitle: 'Chromeブラウザでの作業',
        chromiumdescription: 'ページのスクリーンショットや PDF の作成、フォームの自動送信、UI のテスト、キーボードによるデータ入力、ファイルのダウンロード、ファイルのアップロードなど、ブラウザーで手動で実行できるほとんどの操作をここで実行できます。',
        exceltitle: 'Excel の操作',
        exceldescription: 'Excel でのデータの読み取り、追加、削除、編集などの操作はすべてここで行うことができます。 CSV ファイルの読み取り/書き込み、Excel から CSV への変換なども行えます。',
        gmailtitle: 'Gmail の操作',
        gmaildescription: 'この機能を使用すると、Gmail API を介して Gmail アカウントからメールを送信できます。さらに、メールボックス内のメッセージの検索、コンテンツの取得、添付ファイルのダウンロードなどを行うことができます。',
        googlespreadsheettitle: 'Google スプレッドシートの操作',
        googlespreadsheetdescription: 'この機能を使用すると、Google Spreadsheet API を使用してワークシート内のデータを読み取り、追加、削除、編集できます。シートファイルの新規追加、コピー、ダウンロード等も可能です。',
        googledrivetitle: 'Google ドライブの操作',
        googledrivedescription: 'この機能を使用すると、Google Drive API を介したアップロードやダウンロードなど、ドライブ内のファイルを管理できます。',
        googlecalendartitle: 'Google カレンダーの操作',
        googlecalendardescription: 'この機能を使用すると、Google Calendar API を通じてカレンダーとイベントを管理できます。',
        googledocstitle: 'Google ドキュメントの操作',
        googledocsdescription: 'この機能を使用すると、Google Calendar API を介してすべてのドキュメントの読み取り/書き込みが可能になります。',
        awss3title: 'AWS S3 の操作',
        awss3description: 'AWS S3と連携することで、ファイルを読み込んでS3バケットに保存することができます。 S3 バケット操作権限は、AWS コンソールで指定された IAM 権限です。',
        filemakertitle: 'FileMaker の使用',
        filemakerdescription: 'FileMakerが提供するAPIをもとに、FileMaker上でレコードの読み取り・追加・削除・編集を行ったり、FileMaker上でスクリプトを実行したりすることができます。',
        texttitle: 'テキスト ファイルの操作',
        textdescription: 'txt/PDF ファイルをテキストに変換します。また、分割・置換なども対応できます。　　　　',
        docs: 'Google ドキュメント',
        filemaker: 'ファイルメーカー',
        awss3: 'AWS S3',
        clientid: 'クライアントID',
        to: 'へ',
        subject: '件名',
        body: '内容',
        attachments: '添付',
        from: 'から',
        cc: 'CC',
        bcc: 'BCC',
        query: 'クエリ',
        limit: 'リミット',
        markasread: '既読にする',
        gmailmessages: 'Gmail メッセージ',
        calendarid: 'カレンダーID',
        summary: 'まとめ',
        descriptions: '説明',
        eventid: 'イベントID',
        attendees: '出席者',
        fileid: 'ファイルID',
        spreadsheetid: 'スプレッドシートID',
        title: 'タイトル',
        spreadsheet: 'Google スプレッドシート',
        spreadsheetdestination: 'スプレッドシート (宛先)',
        sheetnamedestination: 'シート名(保存先)',
        extension: '拡大',
        method: '方法',
        params: 'パラメータ',
        httpheaders: 'ヘッダー',
        layout: 'レイアウト',
        parameters: 'パラメータ',
        fielddata: 'フィールドデータ',
        recordid: 'レコードID',
        scriptname: 'スクリプト名',
        containerfieldname: 'コンテナフィールド名',
        globalfields: 'グローバルフィールド',
        webservice: 'ウェブサービス',
        msg_cannotrunschedulerightnow: 'スケジュールは実行中ですが、現在スケジュールを実行できません。',
        msg_scheduleisdisabled: 'スケジュールが無効になっています',
        msg_schedulehasrunsuccessfully: 'スケジュールは正常に実行されました。',
        createyouritemandstartexperimentingnow: ' {item}を作成して今すぐ実験を始めてください。',
        script: 'スクリプト',
        passwords: 'パスワード',
        documentid: 'ドキュメント ID',
        document: 'ドキュメント',
        index: '指数',
        function: '機能',
        functions: '機能',
        subtitle__actiontask_miscellaneous: 'RPA CLOUD の使用を開始するための基本的なアクションです。',
        parameters__title: 'パラメータ (* は必須パラメータです)',
        parameters__name: '名前',
        parameters__type: 'タイプ:',
        parameters__description: '説明',
        parameters__default: 'デフォルト',
        returndatatype__title: '戻り値のデータ型',
        example__title: '例',
        datatype__text: 'テキスト',
        datatype__number: '番号',
        datatype__array: '配列 (JSON)',
        datatype__object: 'オブジェクト (JSON)',
        datatype__boolean: 'ブール値',
        datatype__any: '任意',
        dependingonstoredvalue: '(保存された値に応じて',
        subtitle__actiontask_browser: 'ブラウザのアクションのリスト。ブラウザのアクションは、ブラウザの起動やブラウザ内でのクリックなどのアクティビティに対応します。ブラウザなどで要素を操作するためのCSSセレクターを設定します。',
        supplement__title: '補足',
        textonly: 'テキストのみ',
        typetext: 'テキスト入力',
        typepassword: 'パスワード入力',
        keyboardpress: 'キーボード押下',
        gettext: 'テキスト取得',
        clickpoint: '座標クリック',
        takescreenshot: 'スクリーンショット撮影',
        pagepdf: 'ページ PDF',
        hover: 'マウスホバー',
        scrapepage: 'スクレイピング',
        findelement: '要素検索',
        geturl: 'URL取得',
        getattribute: '属性取得',
        waitforselector: 'セレクターを待つ',
        draganddrop: 'ドラッグ＆ドロップ',
        injectjavascript: 'Javascript挿入',
        gotourl: 'URLに移動',
        goback: '戻る',
        switchtab: 'タブ切替',
        showtabs: 'タブ表示',
        closebrowser: 'ブラウザを閉じる',
        subtitle__actiontask_storages: 'ストレージ内のファイルまたはフォルダーを操作するためのアクションリストです。',
        listfiles: 'ファイルの一覧表示',
        renamefile: 'ファイル名変更',
        movefiles: 'ファイル移動',
        deletefiles: 'ファイル削除',
        copyfiles: 'ファイル複製',
        compressfiles: 'ファイル圧縮',
        decompressfiles: 'ファイル解凍',
        subtitle__actiontask_json: '配列・変数などのデータを取り扱うアクションリストです。',
        getelementfromarray: '配列から要素取得',
        getvaluefromobject: 'オブジェクトから要素取得',
        subtitle__actiontask_text: '文字列を操作するアクションリストです。',
        createtext: 'テキスト作成',
        splittext: 'テキスト分割',
        replacetext: 'テキスト置換',
        matchtext: 'テキストのマッチング',
        readtext: 'テキスト読込',
        convertpdftotext: 'PDF をテキストに変換',
        convertexceltocsv: 'エクセルを CSV に変換',
        subtitle__actiontask_excel: 'Excelファイルの操作を行うアクションリストです。',
        createnewfile: '新規ファイル作成',
        getsheetnames: 'シート名の取得',
        changesheetname: 'シート名の変更',
        selectsheet: 'シート選択',
        readcell: 'セル読込',
        writecell: 'セル書込',
        readrange: '範囲読込',
        writerange: '範囲書込',
        deleterange: '範囲削除',
        appendvaluetotextfile: 'テキスト ファイルに値を追加',
        writecsv: 'CSV書込',
        readcsv: 'CSV読込',
        appendvaluetocsvfile: "CSV ファイルに値を追加",
        companyname: '会社名',
        telnumber: '電話番号',
        subtitle__actiontask_gmail: 'Google メール連携に関するアクション一覧です。',
        sendmail: 'メール送信',
        getgmail: 'メール取得',
        gmaildownloadattachments: '添付ファイル取得',
        subtitle__actiontask_calendar: 'Google カレンダー連携に関するアクション一覧です。',
        getcalendarevents: 'カレンダーイベント取得',
        createcalendarevent: 'カレンダーイベント作成',
        removecalendarevent: 'カレンダーイベント削除',
        subtitle__actiontask_drive: 'Google ドライブを操作するアクション一覧です。',
        createdrivefile: 'ドライブファイル作成',
        getdrivefile: 'ドライブファイル取得',
        subtitle__actiontask_docs: 'Googleドキュメントを操作するアクション一覧です。',
        createdocs: 'ドキュメント作成',
        getdocs: 'ドキュメント取得',
        docsinsertparagraph: 'ドキュメントに文節追加',
        subtitle__actiontask_spreadsheets: 'Googleスプレッドシートを操作するアクション一覧です。',
        createspreadsheet: 'スプレッドシート作成',
        getspreadsheet: 'スプレッドシート取得',
        getvalues: '値の取得',
        updatevalues: '値の更新',
        appendvalues: '値の追加',
        clearvalues: '値の削除',
        duplicatesheet: 'シート複製',
        downloadsheets: 'シート出力',
        appendsheet: 'シート追加',
        subtitle__actiontask_awss3: 'AWS S3 を操作するアクション一覧です。',
        uploads3file: 'S3 ファイルアップロード',
        downloads3file: 'S3 ファイルダウンロード',
        subtitle__actiontask_webservice: 'HTTP 操作するアクション一覧です。',
        httprequest: 'HTTPリクエスト',
        getfilefromurl: 'URLからファイル取得',
        subtitle__actiontask_filemaker: 'FileMaker を操作するアクション一覧です。',
        getrecords: 'レコード取得',
        createrecord: 'レコード作成',
        getsinglerecordbyid: 'IDでレコード取得',
        editrecord: 'レコード編集',
        deleterecord: 'レコード削除',
        duplicaterecord: 'レコード複製',
        findrecords: 'レコード検索',
        executescript: 'スクリプト実行',
        uploadtocontainerfield: 'コンテナフィールドにアップ',
        setglobalfields: 'グローバルフィールド設定',
        subtitle__actiontask_control: 'コントロル操作するアクション一覧です',
        loop: '繰り返し',
        forearch: '各要素について繰り返し',
        breakif: '繰り返しを中断',
        wait: '待機',
        runrobot: 'ロボット実行',
        utcoffset: 'UTC オフセット',
        subtitle__connections_gmail: 'Gmail APIと連携すると、連携したアカウントからメールを送信するアクションを利用できます。',
        createaconnectionwithgmail: 'Gmail との接続を作成する',
        subtitle__connections_drive: 'Google Drive APIと連携することで、アクション上でGoogle Driveからファイルの取得、アップロード、削除などの操作を行うことができます。',
        createaconnectionwithdrive: 'Google ドライブとの接続を作成する',
        subtitle__connections_calendar: 'Google Calendar APIと連携することで、アクションを利用してGoogle Calendarから情報を取得することができます。',
        createaconnectionwithcalendar: 'Google カレンダーとの接続を作成する',
        subtitle__connections_docs: 'Google Docs APIと連携することで、Google Docsの作成・取得・編集が可能になります。',
        createaconnectionwithdocs: 'Google ドキュメントとのつながりを作成する',
        subtitle__connections_spreadsheet: 'Google Spreadsheet APIと連携することで、スプレッドシートの新規作成やセルの操作などのアクションを利用できます。',
        createaconnectionwithspreadsheet: 'Google スプレッドシートとの接続を作成する',
        subtitle__connections_awss3: 'AWS S3と連携することで、アクション内でS3バケットからファイルを取得したり、バケットにファイルを保存したりすることができます。 S3 バケットを操作する権限は、AWS コンソールで指定された IAM 権限になります。この連携は、固定バケットとの連携である。',
        createaconnectionwithawss3: 'AWS S3 との接続を作成する',
        subtitle__connections_ftp: 'FTP にリンクすると、ファイルをダウンロードしたり、FTP にファイルをアップロードしたりできます。',
        createaconnectionwithftp: 'FTP で接続を作成する',
        subtitle__connections_filemaker: 'FileMaker API とリンクすると、アクションを使用してレコードの作成、編集、削除、スクリプトの実行などを行うことができます。',
        createaconnectionwithfilemaker: 'FileMaker との接続を作成する',
        subtitle__functions_get: '取得',
        fxgetcurrentdate: 'GetCurrentDate(UTC オフセット , フォーマット)',
        fxgetcurrenttime: 'GetCurrentTime(UTC オフセット , フォーマット)',
        fxgetcurrenttimestamp: 'GetCurrentTimestamp(UTC オフセット , フォーマット)',
        fxgetfilesizeiniytes: 'GetFilesizeInBytes(ファイルパス)',
        fxgetnumberoffiles: 'GetNumberOfFiles(ディレクトリ)',
        fxgetscriptparameter: 'GetScriptParameter()',
        subtitle__functions_date: '日付',
        fxday: 'Day(日付)',
        fxdayname: 'DayName(日付)',
        fxdayofweek: 'DayOfWeek(日付)',
        fxdayofyear: 'DayOfYear(日付)',
        fxmonth: 'Month(日付)',
        fxmonthname: 'MonthName(日付)',
        fxweekofyear: 'WeekOfYear(日付)',
        fxyear: 'Year(日付)',
        fxsetdate: 'SetDate(年, 月, 日, フォーマット)',
        subtitle__functions_text: 'テキスト',
        fxtostring: 'ToString(任意)',
        fxleft: 'Left(テキスト , 文字数)',
        fxmiddle: 'Middle(テキスト , 開始 , 文字数)',
        fxright: 'Right(テキスト , 文字数)',
        fxstringlength: 'StringLength(テキスト)',
        fxtolower: 'ToLower(テキスト)',
        fxtoupper: 'ToUpper(テキスト)',
        fxpatterncount: 'PatternCount(テキスト , 検索文字列)',
        fxsubstitute: 'Substitute(テキスト , [[ 検索文字列 , 変換文字列 ]])',
        fxtotrim: 'ToTrim(テキスト)',
        fxtotrimall: 'ToTrimAll(テキスト)',
        fxindexofstring: 'IndexOfString(テキスト , 検索文字列)',
        fxsplit: 'Split(テキスト , と分割)',
        fxmatch: 'Match(テキスト , 正規表現)',
        subtitle__functions_number: '数字',
        fxtonumber: 'ToNumber(テキスト)',
        fxrandom: 'Random()',
        fxtoceiling: 'ToCeiling(数字)',
        fxtofloor: 'ToFloor(数字)',
        subtitle__functions_logical: '論理',
        fxif: 'If(条件 , 結果 1 , 結果 2)',
        fxcase: 'Case([[ 条件 , 結果 ]] , デフォルト結果)',
        fxisempty: 'IsEmpty(テキスト)',
        year: '年',
        month: '月',
        day: '日',
        numberofcharacters: '文字数',
        searchstring: '文字列検索',
        replacestring: '文字列置換',
        results: '結果',
        defaultresult: 'デフォルト結果',
        companycategory: '会社カテゴリー',
        new: '新規',
        existing: '既存',
        excludingholidays: '祝日は実行しません。',
        excludingweekends: '土日は実行しません',
        else: '偽のとき < 処理',
        endloop: '繰り返し < 終了',
        foreach: '各要素に対して繰り返し',
        endforeach: '各要素に対して繰り返し終了',
        viewfile: 'ファイル閲覧',
        sendgmail: 'メール送信',
        allowedfilesextensionsareasfollows: '許可されるファイル拡張子は次のとおりです',
        rpacloudssubtitle: 'より多くの時間、より多くの機会',
        highlightfeatures: [
            {
                title: '個人向け'
                , content: '豊富なパッケージで個別ニーズに対応する唯一のRPAツールです。'
            },
            {
                title: '柔軟性'
                , content: 'いつでもどこからでもアクセスできるため、ユーザーは自動化プロセスをリモートで簡単に管理できます。'
            },
            {
                title: '多機能性'
                , content: 'コーディングの知識がなくても、一連の機能を利用して反復的なタスクを簡単に自動化できます。'
            }
        ],
        frequentlyaskedquestion: 'よくある質問',
        frequentlyaskedquestions: [
            {
                question: 'RPA CLOUDを使用して自動化できる業務は何ですか?'
                , answer: "Excel、Gmail、Google スプレッドシート、FileMaker などのプラットフォームでのタスク (情報の転送、Web からのデータ抽出、ファイルの管理、電子メールの自動送信など)。特定のタスクを自動化できるかどうか不明な場合は、詳しい情報とサポートについてお気軽にお問い合わせください。"
            },
            {
                question: 'RPA CLOUD を実装するにはどのようなプログラミング言語またはスキルが必要ですか?'
                , answer: "ロボットを作成するのに特別なスキルは必要ありません。ドキュメントに従うだけで、ロボットを開発できます。"
            },
            {
                question: 'どのようなサポートが受けられますか?'
                , answer: '電子メールとビデオ通話によるサポートをご提供いたします。'
            }
        ],
        footerslogan: "理想的なアシスタントを構築しよう",
        footerscription: "ロボットの力を使って日常業務から解放されましょう!",
        getstarted: '始めましょう',
        introduceblog: "RPA CLOUD は、誰もが自分のアシスタントが自分の潜在的な創造性を解き放ち、個人の追求にもっと充実した時間を割いてくれることを望んでいると考えています。",
        resources: "リソース",
        position: 'ポジション',
        notice: "通知",
        gobackconfirm: "戻る前に変更を保存しますか?",
        ftp: 'FTP',
        secure: 'セーフ',
        subtitle__actiontask_ftp: 'FTP サーバーを操作するアクション一覧です。',
        uploadfiletoftp: 'FTPにファイルをアップロード',
        downloadfilefromftp: 'FTPにファイルをダウンロード',
        destinationdirectory: '対象ディレクトリ',
        remarks: '備考',
        delimiter: 'デリミタ',
        changedelimitercsvfile: 'CSVファイルにデリミタ変更',
        returndatatype__noreturndata: '戻りデータなし',
        extractdatafromtable: "テーブルからデータ抽出",
        company: '会社',
        users: 'ユーザー数',
        closetab: "タブを閉じる",
        opennewtab: "新タブを開く",
        clip: "クリップ",
        addnewcompany: "新規会社追加",
        editcompany: "会社更新",
        msg_addnewcompanysuccess: '新規会社が追加されました。',
        msg_updatecompanysuccess: '会社が更新されました。',
        msg_inactivecompanywassuccess: '会社が無効されました。',
        msg_activecompanywassuccess: '会社が有効されました。',
        msg_deletecompanywassuccess: '会社が削除されました。',
        confirmactioncompany: '選択された会社を {action}したいですか?',
        company_profile: '会社概要',
        handling_of_personal_information: '個人情報の取り扱いについて',
        show_histories: '履歴の表示/非表示',
    },
}

export default ja;